import React, { useEffect, useState } from "react";
import "./risk-level-management-content.component.scoped.scss";
import { Box, Button, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { RiskLevelsService } from "../../../../services/riskLevels.services";
import {
  formatDate,
  showPopupToastMsg,
  showToastMsg,
} from "../../../../helpers";
import { icons } from "../../../../statics/icons";
import AddRiskLevelModal from "../../modals/add-risk-level/add-risklevel.modal";

const RiskLevelManagementContentComponent = () => {
  const { t } = useTranslation();
  const riskLevelsService = new RiskLevelsService();
  const [riskLevels, setRiskLevels] = useState<any>([]);
  const [showRiskLevelModal, setShowRiskLevelModal] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [riskLevel, setRiskLevel] = useState<any>({});

  const fetchRiskLevels = async () => {
    const response = await riskLevelsService.listSettings();
    setRiskLevels(response);
  };

  const handleClose = (value: any) => {
    if (value) {
      fetchRiskLevels();
    }
    setIsEditable(false);
    setRiskLevel({});
    setShowRiskLevelModal(false);
  };

  const editRiskLevel = (row: any) => {
    setIsEditable(true);
    setRiskLevel(row);
    setShowRiskLevelModal(true);
  };

  const deleteRiskLevel = async (id: number) => {
    const response = await riskLevelsService.delete(id);
    if (response.message === "SUCCESS") {
      showToastMsg("success", t("RISK_LEVEL_DELETED_SUCCESSFULLY"));
      setRiskLevels((prev: any) =>
        prev.filter((document: any) => document.id !== id),
      );
    } else {
      showPopupToastMsg("error", t("SOME_THING_WENT_WRONG"));
    }
  };

  useEffect(() => {
    fetchRiskLevels();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="global__box__content mb-4 p-0">
      <Box className="title">
        <Typography variant="subtitle1" style={{ fontWeight: 400 }}>
          {t("SETTINGS_PAGES.RISK_LEVEL_MANAGEMENT.LIST_OF_RISK_LEVELS")}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          className="btn-primary-theme"
          size="small"
          onClick={setShowRiskLevelModal.bind(null, true)}
        >
          {t("SETTINGS_PAGES.RISK_LEVEL_MANAGEMENT.CREATE_NEW_RISK_LEVEL")}
        </Button>
      </Box>
      <Box className="content">
        {riskLevels.map((riskLevel: any, index: number) => {
          return (
            <Box
              className="item d-flex align-items-center justify-content-between mb-3"
              key={index}
            >
              <Box
                className="d-flex align-items-center"
                style={{ gap: "1rem" }}
              >
                <img src={icons.DOCUMENT} alt="DOCUMENT" />
                <Box className="info">
                  <Box
                    className="d-flex align-items-center mb-1"
                    style={{ gap: ".5rem" }}
                  >
                    <Typography variant="subtitle2" style={{ fontWeight: 500 }}>
                      {riskLevel.slug}
                    </Typography>
                    <span className="date">
                      {t("CREATED_AT")}{" "}
                      {formatDate(riskLevel.createdAt, "DD.MM.YYYY")}
                    </span>
                  </Box>
                  <Typography variant="body1">{riskLevel.name_en}</Typography>
                  <Typography variant="body1">{riskLevel.name_de}</Typography>
                </Box>
              </Box>
              <Box className="actions">
                <Button
                  variant="contained"
                  color="secondary"
                  style={{
                    color: "#fff",
                    background: "var(--secondary)",
                    fontSize: "1rem",
                    fontWeight: 300,
                    textTransform: "capitalize",
                  }}
                  className="mr-2"
                  size="small"
                  onClick={() => editRiskLevel(riskLevel)}
                >
                  {t("EDIT")}
                </Button>
                <Button
                  variant="text"
                  style={{
                    textDecoration: "underline",
                    color: "var(--secondary)",
                    fontSize: "1rem",
                    fontWeight: 300,
                    textTransform: "capitalize",
                  }}
                  onClick={() => deleteRiskLevel(riskLevel.id)}
                  size="small"
                >
                  {t("DELETE")}
                </Button>
              </Box>
            </Box>
          );
        })}
      </Box>

      {showRiskLevelModal && (
        <AddRiskLevelModal
          show={showRiskLevelModal}
          onClose={handleClose}
          riskLevel={riskLevel}
          editable={isEditable}
        />
      )}
    </Box>
  );
};

export default RiskLevelManagementContentComponent;
